export default __webpack_public_path__ + "608227c5c4f0a8115f1072df8813d221.jpg";